export const NOTIFICATION_TITLE_MAX_LENGTH = 35;
